import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

export const contentEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = contentEntityAdapter.getInitialState({
  selectedContentType: "sports_keymoments",
});

export const contentSlice = createSlice({
  name: "content",
  initialState: initialState,
  reducers: {},
  extraReducers: () => {},
});

export default contentSlice.reducer;
